/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';

/**
 * Broker information. Required if cross border.
 * @export
 * @interface Broker
 */
export interface Broker {
    /**
     * 
     * @type {string}
     * @memberof Broker
     */
    businessName: string;
    /**
     * 
     * @type {Address}
     * @memberof Broker
     */
    address: Address;
    /**
     * 
     * @type {Contact}
     * @memberof Broker
     */
    contact: Contact;
    /**
     * Broker account number
     * @type {string}
     * @memberof Broker
     */
    accountNumber?: string;
}

/**
 * Check if a given object implements the Broker interface.
 */
export function instanceOfBroker(value: object): value is Broker {
    if (!('businessName' in value) || value['businessName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('contact' in value) || value['contact'] === undefined) return false;
    return true;
}

export function BrokerFromJSON(json: any): Broker {
    return BrokerFromJSONTyped(json, false);
}

export function BrokerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Broker {
    if (json == null) {
        return json;
    }
    return {
        
        'businessName': json['businessName'],
        'address': AddressFromJSON(json['address']),
        'contact': ContactFromJSON(json['contact']),
        'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
    };
}

  export function BrokerToJSON(json: any): Broker {
      return BrokerToJSONTyped(json, false);
  }

  export function BrokerToJSONTyped(value?: Broker | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businessName': value['businessName'],
        'address': AddressToJSON(value['address']),
        'contact': ContactToJSON(value['contact']),
        'accountNumber': value['accountNumber'],
    };
}

